import React, { useEffect, useState, useCallback } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Stack,
  Button,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Trip_Deactivate_All_Count_GetRow } from "../../Server/ApiV2";
import moment from "moment";
import { PurchaseSummaryModal } from "../Purchase/PurchaseSummaryModal";
import { getStatusStyleV1 } from "../../Utility/Utilitys";

const excelColumns = [
  { field: "TransId", headerName: "Trans Id", width: 70, align: "center" },
  {
    field: "TransDate",
    headerName: "Date",
    width: 85,
    align: "center",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
  },
  { field: "TripId", headerName: "Trip Id", width: 70, align: "center" },
  {
    field: "TripName",
    headerName: "Trip Name",
    minWidth: 160,
    flex: 1,
    align: "left",
  },
  {
    field: "Status",
    headerName: "Status",
    width: 80,
    align: "center",
    renderCell: (params) => {
      const style = getStatusStyleV1(params.value);
      return (
        <div
          style={{
            ...style,
            padding: "2px 8px",
            borderRadius: "4px",
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
          }}
        >
          {params.value}
        </div>
      );
    },
  },
  {
    field: "Narr",
    headerName: "Narration",
    minWidth: 240,
    flex: 1,
    align: "left",
  },
  {
    field: "EnDt",
    headerName: "Entry Date",
    width: 95,
    align: "center",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "EnByName",
    headerName: "Entered By",
    minWidth: 120,
    flex: 1,
    align: "left",
  },
];

const purchaseColumns = [
  {
    field: "A_TransId",
    headerName: "Trans Id",
    width: 70,
    align: "center",
  },
  {
    field: "A_TransDate",
    headerName: "Date",
    width: 85,
    align: "center",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_RefTransId",
    headerName: "Ref Trans ID",
    width: 100,
    align: "center",
  },
  {
    field: "A_RefDate",
    headerName: "Ref Trans Date",
    width: 100,
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_RefNo",
    headerName: "Ref No",
    width: 90,
    align: "left",
  },
  {
    field: "A_Currency",
    headerName: "Currency",
    width: 70,
    align: "left",
  },
  {
    field: "A_Exchange_Rate",
    headerName: "Exchange Rate",
    width: 105,
    align: "right",
  },
  {
    field: "A_Vendor",
    headerName: "Vendor",
    minWidth: 90,
    flex:1,
    align: "left",
  },
  {
    field: "A_Narration",
    headerName: "Narration",
    minWidth: 140,
    flex: 1,
    align: "left",
  },
  {
    field: "status",
    headerName: "Status",
    width: 80,
    align: "left",
    renderCell: (params) => {
      const style = getStatusStyleV1(params.value);
      return (
        <div
          style={{
            ...style,
            padding: "2px 8px",
            borderRadius: "4px",
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
          }}
        >
          {params.value}
        </div>
      );
    },
  },
  {
    field: "EnByName",
    headerName: "Entered By",
    width: 110,
    align: "left",
  },
];

const orderColumns = [
  {
    field: "TransId",
    headerName: "Trans Id",
    width: 70,
    align: "center",
  },
  {
    field: "Date",
    headerName: "Date",
    width: 85,
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "LocName",
    headerName: "Location",
    minWidth: 120,
    flex: 1,
    align: "left",
  },
  {
    field: "GroupName",
    headerName: "Group Name",
    minWidth: 120,
    flex: 1,
    align: "left",
  },
  {
    field: "LeadDays",
    headerName: "Lead Days",
    width: 90,
    align: "center",
  },
  {
    field: "ForecastDays",
    headerName: "Forecast Days",
    width: 100,
    align: "center",
  },
  {
    field: "AnalysisDays",
    headerName: "Analysis Days",
    width: 100,
    align: "center",
  },
  {
    field: "DocStatus",
    headerName: "Doc Status",
    width: 90,
    align: "center",
    renderCell: (params) => {
      const style = getStatusStyleV1(params.value);
      return (
        <div
          style={{
            ...style,
            padding: "2px 8px",
            borderRadius: "4px",
            textAlign: "center",
            width: "100%",
            fontWeight: "bold",
          }}
        >
          {params.value}
        </div>
      );
    },
  },
  {
    field: "FromDate",
    headerName: "From Date",
    width: 90,
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "ToDate",
    headerName: "To Date",
    width: 90,
    align: "left",
    valueFormatter: ({ value }) =>
      moment(value).format("DD/MM/YYYY") == "Invalid date"
        ? ""
        : moment(value).format("DD/MM/YYYY"),
  },
];

export default function TripDeactivateSideNav({ selectedRow ,isOpen, onClose ,summaryData,summaryLoad,isMobile,UserCd}) {
  const [excelRows, setExcelRows] = useState([]);
  const [purchaseRows, setPurchaseRows] = useState([]);
  const [orderRows, setOrderRows] = useState([]);
  const [isModalopen, setIsModalopen] = useState(false);

  const fGetrow = useCallback(async () => {
    try {
      const result = await Trip_Deactivate_All_Count_GetRow({
        TripId: selectedRow?.TripId,
      });
      if (result?.status === 200) {
        const rs = result?.data?.ResultSet || {};
        setExcelRows(rs.Excel || []);
        setPurchaseRows(rs.Purchase || []);
        setOrderRows(rs.Order || []);
      }
    } catch (err) {
      console.error(err);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (isOpen)
    fGetrow();         
  }, [isOpen]);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      PaperProps={{
        sx: { width: { xs: "100%", sm: "80%", md: "70%" } },
      }}
    >
      <Box
        sx={{
          backgroundColor: "#1e88e5 ",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 1.5,
          py: 0.5,
          marginTop: "45px",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 500, marginLeft: "8px" }}>
          {`Trip Id : ${selectedRow?.TripId}, Name : ${selectedRow?.Name} - Deactivate`}
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{
            color: "#ffffff",
            backgroundColor: "rgba(255,255,255,0.15)",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.25)",
            },
          }}
        >
          <Close />
        </IconButton>
      </Box>
      <Box p={1}>
        {" "}
        {/* Order Grid */}
        <Typography variant="h6" mb={0.3}>
          Order
        </Typography>
        <Box height={195}>
          <DataGridPro
            rows={orderRows}
            columns={orderColumns}
            getRowId={(row) => row.TransId}
            density="compact"
            hideFooter
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
          />
        </Box>
        {/* Purchase Grid */}
        <Typography variant="h6" mb={0.3}>
          Purchase
        </Typography>
        <Box height={195}>
          <DataGridPro
            rows={purchaseRows}
            columns={purchaseColumns}
            getRowId={(row) => row.A_TransId}
            density="compact"
            hideFooter
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
          />
        </Box>
        {/* Excel Grid */}
        <Typography variant="h6" mb={0.3}>
          Excel
        </Typography>
        <Box height={195}>
          <DataGridPro
            rows={excelRows}
            columns={excelColumns}
            getRowId={(row) => row.TransId}
            density="compact"
            hideFooter
            sx={{
              border: 1,
              borderColor: "primary.light",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#0d73bb",
                color: "white",
              },
            }}
          />
        </Box>
        <Stack direction={"row"} justifyContent={"flex-end"} mt={0.5}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => setIsModalopen(true)}
          >
            Detail
          </Button>
        </Stack>
      </Box>
      <PurchaseSummaryModal
        isFromPurchaseClose={true}
        open={isModalopen}
        onClose={() => setIsModalopen(false)}
        header={selectedRow}
        isMobile={isMobile}
        onLoad={summaryLoad}
        UserCd={UserCd}
        importPurchaseRows={summaryData}
      />
    </Drawer>
  );
}
